import { render } from "./EnvirosenseBanner.vue?vue&type=template&id=31d1f340&scoped=true"
import script from "./EnvirosenseBanner.vue?vue&type=script&lang=js"
export * from "./EnvirosenseBanner.vue?vue&type=script&lang=js"

import "./EnvirosenseBanner.vue?vue&type=style&index=0&id=31d1f340&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d1f340"]])

export default __exports__